export default {
    'nav.home': '首页',
    'nav.game': '游戏',
    'nav.about': '关于海彼',
    'nav.career': '加入我们',
    'nav.contact': '联系合作'
};
